import { Presentation } from '@features/powerpoint';

type BaseSubdimension = {
  name: string;
  [key: string]: unknown;
};

export const computeDimensionSelection = <T extends BaseSubdimension>(
  subdimensions: T[],
  selectedDimensionSlugs: string[],
  apiSlugToDimensionName: Record<string, string>
) => {
  const selectedDimensionNames = selectedDimensionSlugs.map(
    dimensionSlug => apiSlugToDimensionName[dimensionSlug]
  );

  const selectedSubdimensions = subdimensions.filter(subdimension =>
    selectedDimensionSlugs.includes(subdimension.name)
  );

  return {
    selectedDimensionSlugs,
    selectedDimensionNames,
    selectedSubdimensions,
  };
};

export const layout = {
  name: 'CUSTOM_WIDESCREEN',
  height: 7.5,
  width: 13.33,
} as const satisfies Presentation['layout'];

export const marginLeft = 0.74;
